export default __webpack_public_path__ + "static/media/header-bg.479659b1.svg";